import EnrollmentAcknowledgement from "../../enrollmentAcknowledgement/EnrollmentAcknowledgement";
import { useState, useEffect, useContext, useCallback, useMemo } from "react";
import { VEBPlanAcknowledgementProps } from "../../../../../types/components/enrollmentProps.types";
import { VEBEnrollmentSchema } from "../../../../../types/enrollment.types";
import { AuthContext, ThemeContext } from "../../../../../contexts";
import { Paper, Grid, Button } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { getFirstOfNextMonth } from "../../../../../utils/commonFunctions/date";
import { VEB_PLAN_NAMES } from "../../../../../constants/plan";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../utils/api";

const VEBPlanAcknowledgement = ({
	VEBEnrollments,
	VEBOpenEnrollment,
	VEBPlanName,
	handleStackEnrollmentClick
}: VEBPlanAcknowledgementProps & any): JSX.Element => {
	const { theme } = useContext(ThemeContext);
	const [VEBEnrollment, setVEBEnrollment] = useState<VEBEnrollmentSchema>();
	const { member } = useContext(AuthContext);
	const location = useLocation();
	const history = useHistory();
	const [planCode, setPlanCode] = useState<string>();
	const [VEBOpenEnrollmentId, setVEBOpenEnrollmentId] = useState<string>();

	const [isStackedPlan, setIsStackedPlan] = useState<boolean>(false);
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	// console.log("VEBEnrollment", VEBEnrollments);

	// const stackedPlan = VEBEnrollments.filter(
	// 	(vebEnrollment: any) => vebEnrollment.base_plan_name === VEBPlanName && vebEnrollment.is_stacked == true
	// );

	const findPlanEnrollment = useCallback(() => {
		if (!member) {
			return;
		}
		for (let enrollmentIdx = 0; enrollmentIdx < VEBEnrollments.length; enrollmentIdx++) {
			const _enrollment = VEBEnrollments[enrollmentIdx];
			if (
				_enrollment.member_SSN === member.SSN &&
				_enrollment.insured_SSN === member.SSN &&
				_enrollment.plan_name === VEBPlanName &&
				_enrollment.base_plan_name === VEBPlanName
			) {
				setVEBEnrollment(Object.assign({}, _enrollment));
				break;
			}
		}
	}, [VEBEnrollments, member, VEBPlanName]);

	const getVEBPlanCode = useCallback(
		(VEBOpenEnrollment: any[]) => {
			// // // console.log("**********VEBOpenEnrollment********", VEBOpenEnrollment[0]);
			let _planCode, _VEBOpenEnrollmentId;
			for (let idx = 0; idx < VEBOpenEnrollment.length; idx++) {
				const planName = VEBOpenEnrollment[idx].open_enrollment.veb_plan_name;
				const planCode = VEBOpenEnrollment[idx].open_enrollment.veb_plan_code;
				const VEBOpenEnrollmentId = VEBOpenEnrollment[idx].VEB_open_enrollment_id;
				console.log("<====Plan Name===>", planName);

				if (planName === VEBPlanName || planName === "Group Limited Indemnity") {
					console.log("idxxxxxxxxxxxx", idx);

					_planCode = planCode;
					_VEBOpenEnrollmentId = VEBOpenEnrollmentId;
				}
			}

			setPlanCode(_planCode);
			setVEBOpenEnrollmentId(_VEBOpenEnrollmentId);
		},
		[VEBPlanName]
	);

	const handleEnrollAgainButtonClick = useCallback(() => {
		const step = urlSearchParams.get("step");
		history.push(`?step=${step}&stage=1`);
	}, [history, urlSearchParams]);

	useEffect(() => {
		findPlanEnrollment();
	}, [findPlanEnrollment]);

	// console.log("VEBEnroll", VEBEnrollment);

	// const getPlanDocumnet = useCallback(() => {
	// 	const step = urlSearchParams.get("step");
	// 	switch (step) {
	// 		case "Cancer":
	// 			downloadFile(CancerBrochure, CancerBrochure);
	// 			break;
	// 		case "Whole life":
	// 			downloadFile(WholeLifeBrochure, WholeLifeBrochure);
	// 			break;
	// 		case "Critical Illness":
	// 			downloadFile(CriticalIllnessBrochure, CriticalIllnessBrochure);
	// 			break;
	// 		case "Short Term Disability":
	// 			downloadFile(KemperShortTermBrochure, KemperShortTermBrochure);
	// 			break;
	// 		case "Accident":
	// 			downloadFile(KemperAccidentBrochure, KemperAccidentBrochure);
	// 			break;
	// 		case "Hospital Indemnity":
	// 			downloadFile(HospitalndemnityBrochure, HospitalndemnityBrochure);
	// 			break;
	// 	}
	// }, [urlSearchParams]);

	const getBenefits = useCallback(async () => {
		if (member) {
			const getBenefitsQuery: any = {
				base_plan_name: VEBPlanName,
				// group_number: member.group_number,
				insured_SSN: member.SSN
				// member_SSN: member.SSN
			};
			const benefitsResponse: any = await trackPromise(
				api.enrollment.getActiveVEBEnrollmentWithRider(getBenefitsQuery)
			);

			if (benefitsResponse.isStacked == true) {
				setIsStackedPlan(true);
			} else {
				setIsStackedPlan(false);
			}
		}

		// // console.log("bbb", benefitsResponse);
	}, [VEBPlanName, member]);

	useEffect(() => {
		if (VEBOpenEnrollment && VEBOpenEnrollment.length !== 0) {
			getVEBPlanCode(VEBOpenEnrollment);
			getBenefits();
		}
	}, [VEBOpenEnrollment, getVEBPlanCode, member]);

	console.log("VEBPlanAcknowledgement=========0000000000", VEBEnrollments, VEBOpenEnrollment, VEBPlanName);

	return (
		<div className="paper-form-container">
			<Paper className="theme-border-radius paper-container" elevation={1}>
				{VEBOpenEnrollment && VEBEnrollment ? (
					<EnrollmentAcknowledgement
						idCardAccessPointRequired={true}
						dependentChangePointRequired={true}
						carrierPhoneNo={"(555) 555-1234"}
						carrierWebsite={"brookshirebrothers.com"}
						planDocument={""}
						planName={VEBPlanName}
						addDependentLink={"/home/add-family-member"}
						planCode={planCode as unknown as string}
						removeDependentLink={""}
						status={VEBEnrollment.enrollment_status}
					/>
				) : null}
				<div className="theme-plan-section-margin" />
				{VEBOpenEnrollment && VEBOpenEnrollment.length > 0 ? (
					<>
						{!isStackedPlan && (
							<Grid container>
								<Grid item xl={4} lg={4} xs={12} md={12} sm={12}></Grid>
								<Grid item xl={4} lg={4} xs={12} md={12} sm={12}>
									<Button
										style={{
											backgroundColor: theme.button.background_color,
											color: theme.button.color,
											width: "100%"
										}}
										onClick={handleEnrollAgainButtonClick}
									>
										Enroll again
									</Button>
								</Grid>
								<Grid item xl={4} lg={4} xs={12} md={12} sm={12}></Grid>
							</Grid>
						)}
						{isStackedPlan && handleStackEnrollmentClick && (
							<Grid container>
								<Grid item xl={4} lg={4} xs={12} md={12} sm={12}></Grid>
								<Grid item xl={4} lg={4} xs={12} md={12} sm={12}>
									<Button
										style={{
											backgroundColor: theme.button.background_color,
											color: theme.button.color,
											width: "100%"
										}}
										onClick={handleStackEnrollmentClick}
									>
										Stack again
									</Button>
								</Grid>
								<Grid item xl={4} lg={4} xs={12} md={12} sm={12}></Grid>
							</Grid>
						)}
					</>
				) : null}
			</Paper>
		</div>
	);
};

export default VEBPlanAcknowledgement;
